export enum VariantImageType {
    PRODUCT_ARTIFACT = 'PRODUCT_ARTIFACT',
    SALES_CONDITIONS = 'SALES_CONDITIONS',
    PRODUCT_SAMPLE = 'PRODUCT_SAMPLE',
    COVER_ARTWORK = 'COVER_ARTWORK',
    ADDITIONAL_FILES = 'ADDITIONAL_FILES'
}
